import React, { useEffect, useState } from "react";

//assets
import contact_canada from "../../assets/images/canada.png";
import contact_uk from "../../assets/images/uk.png";
import contact_australia from "../../assets/images/austrila.png";
import contact_dubai from "../../assets/images/dubai.png";
import contact_india from "../../assets/images/india.png";
import { renderImage } from "../../Components/helper/image";
import Validation from "../../Components/helper/validation";
import { Toaster } from "react-hot-toast";
import ContentController from "../../apis/controller/content.controller";

const Midpart = (props) => {
    const [loading, setLoading] = useState(false);
    let defaultValues = {
        firstName: null,
        lastName: null,
        phoneNumber: null,
        email: null,
        message: null,
    };
    const [values, setValues] = useState(defaultValues);

    const [isError, setError] = useState({
        firstName: {
            rules: ["required", "alphabetic"],
            isValid: true,
            message: "",
        },
        lastName: {
            rules: ["required", "alphabetic"],
            isValid: true,
            message: "",
        },
        phoneNumber: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        email: {
            rules: ["required", "email"],
            isValid: true,
            message: "",
        },
        message: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
    });
    let validation = new Validation(isError);

    const handleStates = (field, value) => {
        /** Validate each field on change */
        let node = validation.validateField(field, value);
        setError({ ...isError, [field]: node });
        /** Validate each field on change */
        if (!value || !value.trim()) {
            setValues({ ...values, [field]: "" });
        } else {
            setValues({ ...values, [field]: value });
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        setValues(defaultValues);
    }, []);

    const addContactUs = async () => {
        /** Check full form validation and submit **/
        let validation = new Validation(isError);
        let isValid = await validation.isFormValid(values);
        if (isValid && !isValid.haveError) {
            setLoading(true);
            let response = await new ContentController().contactUsForm(values);
            setLoading(false);
            if (response && response.status) {
                setValues(defaultValues);
                // new Toaster().success(response.message);
            }
        } else {
            setError({ ...isValid.errors });
        }
    };

    return (
        <>
            {props && props.item && <section className="contact_alt_midpart_section">
                <div className="container-fluid p-0">
                    <div
                        data-aos="fade-up"
                        data-aos-delay="1000"
                        className="map"
                    >
                        <div dangerouslySetInnerHTML={{ __html: props.item.map_iframe }} />
                        {/* <iframe
                            className="frame"
                            src={url}
                            width="100%"
                            height="450"
                            allowFullScreen=""
                            loading="lazy"
                        ></iframe> */}
                    </div>
                </div>
                <div className="cont">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                <div className="midpart_area">
                                    <div className="locations">
                                        <div className="row">
                                            {props.item && props.item.country_cards.map((item, index) => (
                                                <div key={index} className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                                    <div data-aos="fade-up" className="place">
                                                        <img
                                                            src={renderImage(item.image, 'small')}
                                                            alt="..."
                                                        />
                                                        <div className="content">
                                                            <p
                                                                className="ad"
                                                            // onClick={() =>
                                                            //     setPar(locations.nod)
                                                            // }
                                                            >
                                                                {item.address}

                                                            </p>
                                                            <span className="ph">
                                                                <i className="fas fa-phone-alt"></i>
                                                                <p>
                                                                    <a href="tel:+91-123456789">
                                                                        {item.phone_number}
                                                                    </a>
                                                                </p>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                <div className="rearward_area">
                                    <div
                                        data-aos="fade-up"
                                        data-aos-anchor-placement="center-bottom"
                                        className="ban"
                                    >
                                        <form>
                                            <p
                                                data-aos="fade-up"
                                                data-aos-delay="400"
                                            >
                                                Leave a comment
                                            </p>
                                            <div className="row">
                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                                    <div
                                                        data-aos="fade-up"
                                                        data-aos-delay="200"
                                                        className="topleft_area"
                                                    >
                                                        <label className="boxes">
                                                            <i className="fas fa-user icon"></i>
                                                            First Name:
                                                            <input type="text"
                                                                onChange={(e) => {
                                                                    handleStates(
                                                                        "firstName",
                                                                        e.target.value
                                                                    );
                                                                }}
                                                                value={
                                                                    values.firstName
                                                                        ? values.firstName
                                                                        : ``
                                                                } />
                                                            {isError.firstName.message ? (
                                                                <p className="valid-helper">
                                                                    {isError.firstName.message}
                                                                </p>
                                                            ) : null}
                                                        </label>
                                                    </div>
                                                </div>

                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                                    <div
                                                        data-aos="fade-up"
                                                        data-aos-delay="300"
                                                        className="topright_area"
                                                    >
                                                        <label className="boxes">
                                                            <i className="fas fa-user icon"></i>
                                                            last Name:
                                                            <input type="text"
                                                                onChange={(e) => {
                                                                    handleStates(
                                                                        "lastName",
                                                                        e.target.value
                                                                    );
                                                                }}
                                                                value={
                                                                    values.lastName
                                                                        ? values.lastName
                                                                        : ``
                                                                }
                                                            />
                                                            {isError.lastName.message ? (
                                                                <p className="valid-helper">
                                                                    {isError.lastName.message}
                                                                </p>
                                                            ) : null}

                                                            <p className="valid-helper">

                                                            </p>

                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                                                    <div
                                                        data-aos="fade-up"
                                                        data-aos-delay="200"
                                                        className="topleft_area"
                                                    >
                                                        <label className="boxes">
                                                            <i className="fas fa-phone-alt icon"></i>
                                                            Phone:
                                                            <input
                                                                type="number"
                                                                onChange={(e) => {
                                                                    handleStates(
                                                                        "phoneNumber",
                                                                        e.target.value
                                                                    );
                                                                }}
                                                                value={
                                                                    values.phoneNumber
                                                                        ? values.phoneNumber
                                                                        : ``
                                                                }
                                                            />{isError.phoneNumber.message ? (
                                                                <p className="valid-helper">
                                                                    {isError.phoneNumber.message}
                                                                </p>
                                                            ) : null}

                                                            <p className="valid-helper">

                                                            </p>

                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                                                    <div
                                                        data-aos="fade-up"
                                                        data-aos-delay="300"
                                                        className="topright_area"
                                                    >
                                                        <label className="boxes">
                                                            <i className="fas fa-envelope icon"></i>
                                                            Email:
                                                            <input
                                                                type="email"
                                                                onChange={(e) => {
                                                                    handleStates(
                                                                        "email",
                                                                        e.target.value
                                                                    );
                                                                }}
                                                                value={
                                                                    values.email
                                                                        ? values.email
                                                                        : ``
                                                                }
                                                            />{isError.email.message ? (
                                                                <p className="valid-helper">
                                                                    {isError.email.message}
                                                                </p>
                                                            ) : null}

                                                            <p className="valid-helper">

                                                            </p>

                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                                    <div
                                                        data-aos="fade-up"
                                                        data-aos-delay="400"
                                                        className="botarea"
                                                    >
                                                        <label className="boxes">
                                                            <i className="fas fa-envelope icon"></i>
                                                            Message:
                                                            <textarea
                                                                type="text"
                                                                placeholder="Write your Message"
                                                                onChange={(e) => {
                                                                    handleStates(
                                                                        "message",
                                                                        e.target.value
                                                                    );
                                                                }}
                                                                value={
                                                                    values.message
                                                                        ? values.message
                                                                        : ``
                                                                }
                                                            />{isError.message.message ? (
                                                                <p className="valid-helper">
                                                                    {isError.message.message}
                                                                </p>
                                                            ) : null}

                                                            <p className="valid-helper">

                                                            </p>

                                                        </label>
                                                        <div className="submit">
                                                            <div className="secondary_btn nav-item"><button type="button" className="btn btn-outline-primary" onClick={() => addContactUs()}>Contact Us</button></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>}
        </>
    );
};

export default Midpart;
